export const slideDown = () => {

  const eventsMore = document.querySelector(".js-events-slide-open");
  const eventsSlide = document.querySelector(".events__slide");
  const eventsHidden = document.querySelector(".events__hidden");

  eventsMore?.addEventListener("click", function(e){

    e.preventDefault();

    

    if ( eventsMore.classList.contains("events__more_open") ){
      eventsSlide.style.height = 0 + "px";
    } else {
      eventsSlide.style.height = eventsHidden.offsetHeight + "px";
    }

    eventsMore.classList.toggle("events__more_open");
    

  });

}